import React from 'react';
import './PageStyles.css';

const IconPlay = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M9 7v10l8-5-8-5z" fill="#fff" />
  </svg>
);

const IconBook = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M12 6c-1.9-1.2-4.4-1.2-6.3 0v12c1.9-1.2 4.4-1.2 6.3 0"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6c1.9-1.2 4.4-1.2 6.3 0v12c-1.9-1.2-4.4-1.2-6.3 0"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 6v12" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconSparkle = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M12 3.2l1.4 3.2L17 8l-3.6 1.6L12 14l-1.4-4.4L7 8l3.6-1.6L12 3.2z" fill="#fff" />
    <path d="M5 16l.8 1.8L7.6 18 6 19.2 5 21l-.6-1.8L3 18l1.4-1.2L4.4 16z" fill="#fff" opacity="0.95" />
  </svg>
);

const IconStopDot = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="5" cy="5" r="4" fill="#fff" />
  </svg>
);

const HowToPage = () => {
  return (
    <div className="page-root">
      <main className="page-content" role="main">
        <div className="top-slogan-container">
          <p className="home-slogan-title">遊び方</p>
        </div>
        <div className="howto-panel">
          <div className="howto-section">
            <div className="howto-icon icon--purple"><IconPlay /></div>
            <div className="howto-body">
              <h2 className="howto-title">操作方法</h2>
              <ul className="howto-list">
                <li>
                  <span className="li-icon li-icon--play" aria-hidden><IconPlay size={18} /></span>
                  <span> <strong>STARTボタン</strong>でリールを回す。</span>
                </li>
                <li>
                  <span className="li-icon li-icon--play" aria-hidden><IconStopDot /></span>
                  <span> <strong>STOPボタン</strong>でリールを止める。たったこれだけ！</span>
                </li>
              </ul>
              <div className="howto-note howto-note--kbd" role="note" aria-label="PCキーボード操作">
                <div className="howto-note-title">※補足：PCの場合はキーボードで操作できます。</div>
                <ul className="howto-note-list" aria-label="キーボードショートカット">
                  <li>
                    <span className="howto-note-label">START</span>
                    <span className="howto-note-sep">：</span>
                    <span className="howto-note-value">
                      <span className="howto-note-key">Space</span>
                    </span>
                  </li>
                  <li>
                    <span className="howto-note-label">STOP</span>
                    <span className="howto-note-sep">：</span>
                    <span className="howto-note-value">
                      <span className="howto-note-key">テンキー1/2/3</span>
                      <span className="howto-note-or">or</span>
                      <span className="howto-note-key">Q/W/E</span>
                    </span>
                  </li>
                  <li>
                    <span className="howto-note-label">KWSKオープン</span>
                    <span className="howto-note-sep">：</span>
                    <span className="howto-note-value">
                      <span className="howto-note-key">Enter</span>
                    </span>
                  </li>
                  <li>
                    <span className="howto-note-label">KWSKクローズ</span>
                    <span className="howto-note-sep">：</span>
                    <span className="howto-note-value">
                      <span className="howto-note-key">ESC</span>
                      <span className="howto-note-or">or</span>
                      <span className="howto-note-key">Backspace</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="howto-section">
            <div className="howto-icon icon--green"><IconBook /></div>
            <div className="howto-body">
              <h2 className="howto-title">ルール</h2>
              <ul className="howto-list">
                <li>
                  <span className="li-icon li-icon--sword" aria-hidden>⚔️</span>
                  <span>敵のHPを0にすることで勝利するゲームです。</span>
                </li>
                <li>
                  <span className="li-icon li-icon--card" aria-hidden>🎰</span>
                  <span>お題に合うコマンドをスロットで揃えて戦います。</span>
                </li>
                <li>
                  <span className="li-icon li-icon--attack" aria-hidden>⚡</span>
                  <span><strong>攻撃</strong>：表示されている問題の正解コマンドが揃うと、敵に攻撃できます。</span>
                </li>
                <li>
                  <span className="li-icon li-icon--boom" aria-hidden>💥</span>
                  <span><strong>ダメージ</strong>：揃いなしの場合、うんこ💩が1個溜まります。3個溜まると爆発し、HPが減ります。</span>
                </li>
                <li>
                  <span className="li-icon li-icon--heal" aria-hidden>🧪</span>
                  <span><strong>HP回復</strong>：正解コマンド以外が揃うと、にんにく🧄を1個ゲットできます。3個貯まるとHPが回復します。</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="howto-section">
            <div className="howto-icon icon--cyan"><IconSparkle /></div>
            <div className="howto-body">
              <h2 className="howto-title">その他</h2>
              <ul className="howto-list">
                <li>
                  <span className="li-icon li-icon--sparkle" aria-hidden>✨</span>
                  <span>正解コマンドが揃うと、スロット右下のKWSKボタンが発光するぞ！何が起こるか押してみよう！</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HowToPage;
